<template>
  <div class="sucursal-categorias-wrapper pa-4">
    <div class="d-flex align-center mb-6">
      <v-btn icon @click="$router.back()" class="mr-2" dark>
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <div>
        <h1 class="text-h4 white--text font-weight-black mb-0">
          Categorías
        </h1>
        <div class="text-caption grey--text text--darken-1">
          Gestión de visibilidad para la sucursal
        </div>
      </div>
    </div>

    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>
<script>
export default {
  name: "SucursalCategoriasHome"
};
</script>

<style scoped>
.sucursal-categorias-wrapper {
  /* Aseguramos que ocupe el ancho pero no fuerce scrolls extraños */
  width: 100%;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.15s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>